import CATEGORIES from '../assets/categories';
import { slugify } from './slug';

// Kategori id'si Türkçe karakter içerebilir (örn. "tatlılar") — URL'de her zaman ASCII slug kullanılır
export const categoryPath = (categoryId, subcategoryId) => {
  if (!categoryId) return '/products';
  const catSlug = slugify(categoryId);
  if (!subcategoryId) return `/products/${catSlug}`;
  return `/products/${catSlug}/${subcategoryId}`;
};

// URL'deki ASCII slug'dan gerçek kategori nesnesini bulur
export const resolveCategoryFromSlug = (catSlugParam) =>
  CATEGORIES.find((c) => slugify(c.id) === catSlugParam);
